<template>
    <div>
        <div class="pad fs20 padtb20">图片无损放大 ，不损失图像质量，支持放大2倍、4倍、8倍和16倍
            <router-link to="/home_imgbig" style="color:red;font-size:14px;float:right;">关于图片放大器功能点击这里</router-link>
        </div>
        <div class="pad box-sizing">
            <div class="flex-row">
                <el-button type="success"  @click="oldDialog=true" style="font-weight: bolder;">+上传图片</el-button>
                <el-button type="primary" @click="feeDialog=true" style="font-weight: bolder;"><em class="iconfont icon-dwzRectangleCopy6"></em>收费标准</el-button>
                <el-popconfirm title="确定删除选中的链接吗？删除后不可恢复！" @confirm="delLinks()" style="margin-left: 10px">
                    <el-button type="danger" slot="reference">删除选中</el-button>
                </el-popconfirm>
                <div class="ml10">
                    <el-button type="primary"    @click="refresh" >
                        <img src="../../assets/images/imgbig/refresh_white.png" class="pic-15"/>
                        刷新</el-button>
                </div>

            </div>
        </div>
        <div class="su-mid box-sizing">
            <el-table  v-loading="isLoading3" :data="tableData" empty-text="暂无数据" @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="添加日期" >
                    <template slot-scope="scope">
                        <div class="lim">{{ scope.row.create_time }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="我上传的图片"  class-name="text-align">
                    <template slot-scope="scope">

                            <a :href="scope.row.img_url" target="_blank">
                                <img :src="scope.row.img_url+'!thumb_cut'" class="pic-50 radius-5"/>
                            </a>
                    </template>
                </el-table-column>

                <el-table-column label="生成的图片"  class-name="text-align">
                    <template slot-scope="scope">
                    <a :href="scope.row.created" target="_blank" v-if="scope.row.created">
                        <img :src="scope.row.created+'!thumb_cut'" class="pic-50 radius-5"/>
                    </a>
                    <span class="color_orange" v-if="scope.row.status==0">等待生成</span>
                        <span class="color_666" v-if="scope.row.status==1">正在生成..</span>
                        <span class="color_red" v-if="scope.row.status==3">生成失败</span>

                        <img  @click="refresh"  v-if="scope.row.status==0 || scope.row.status==1" title="点击刷新" src="../../assets/images/imgbig/refresh.png" class="pic-15"/>

                    </template>
                </el-table-column>
                <el-table-column label="倍数" >
                    <template slot-scope="scope">
                        <div class="lim">{{ scope.row.params }}</div>
                    </template>
                </el-table-column>



            </el-table>
            <div class="pagebar" v-show="total>0">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="total"
                               @current-change="handleCurrentPage"></el-pagination>
            </div>
        </div>

        <el-dialog title="收费标准" :visible.sync="feeDialog" center width="400px">
            <span @click="$router.push('/tabs/vipRecharge')">
                 可免费使用2次，之后开通vip即可继续使用，请开通VIP,点击这里
            </span>
        </el-dialog>


        <el-dialog title="上传图片" :visible.sync="oldDialog" center width="400px" >

            <div class="pad"> 放大倍数：
                <span @click="beishu=2" class="pad510 border-gray"  :class="beishu==2?'bg_blue':''">2倍</span>
                <span @click="beishu=4" class="pad510 border-gray ml10" :class="beishu==4?'bg_blue':''">4倍</span>
                <span @click="beishu=8" class="pad510 border-gray ml10" :class="beishu==8?'bg_blue':''">8倍</span>
                <span @click="beishu=16" class="pad510 border-gray ml10" :class="beishu==16?'bg_blue':''">16倍</span>
            </div>
            <div class="pad"></div>



            <el-upload
                    class="upload-demo"
                    action=""
                    :on-preview="handlePreview"
                    :http-request="Upload"
                    :before-upload="beforeAvatarUpload"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
                    :on-success="handleSuccess"
                    :file-list="fileList"
                    list-type="picture">

                <el-button type="primary">+点击上传</el-button>

                <div class="pad">
                        <div slot="tip" class="el-upload__tip">只能上传图片文件，且不超过5mb</div>
                 </div>
            </el-upload>
            <div class="flex-center mt20">
                <el-button type="primary" size="small" style="margin: auto"  @click="imgAccomplish">完成</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import {client, getFileNameUUID} from "../../utils/oss";

    export default {
        name: "ShortUrlList",
        data() {
            return {
                id:0,
                product_id:4,
                beishu:2,
                isVip: false,
                livecodename: "",
                expUrlClass: "",
                keyword: "",
                fileList:[],
                nameval: '',
                total: 0,
                expTotal: 0,
                currentPage: 1,
                expCurrentPage: 1,
                timeGroup: [],
                expTimeGroup: [],
                classOptions: [],
                excOptions: [],
                tableData: [],
                exportData: [],
                multipleSelection: [],
                qrCodeDialog: false,
                classDialog: false,
                oldDialog:false,
                markDialog: false,
                exportDialog: false,
                replaceDialog: false,
                feeDialog:false,
                amendName:false,
                selClassID: "",
                url:"",
                selUrlID: "",
                btnLoading: false,
                urlMark: "",
                exclusive: "",
                isLoad: true,
                isLoads: false,
                isLoading1: false,
                isLoading2: false,
                isLoading3: false,
                isLoading4: false,
                isLoading5: false,
                orgUrl: "",
                newUrl: "",
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date()) / 1000;

            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times) {
                    this.isVip = true;
                }
            }
            this.getList();
        },
        methods: {
            async getList() {
                this.isLoading3 = true;
                let start = 0;
                let end = 0;
                if (this.timeGroup === null) this.timeGroup = [];
                if (this.timeGroup.length === 2) {
                    start = this.timeGroup[0];
                    end = this.timeGroup[1];
                }
                const getData = {
                    start: Number(start / 1000),
                    end: Number(end / 1000),
                    keyword: this.keyword,
                    product_id:this.product_id,
                    p: this.currentPage,
                };
                const {ret, data} = await this.$api.imgbig.getList(getData);
                this.isLoading3 = false;
                if (ret === 1000) {
                    this.total = Number(data.total);
                    this.tableData = data.list;
                }
            },
            refresh(){
                this.getList();
            },

            async delLinks() {
                console.log('1111');
                const ids = this.selUrlID;
                console.log(ids);
                if (ids === '') {
                    this.$message.error('请选择要删除的链接！');
                    return;
                }
                const {ret} = await this.$api.imgbig.del({ids: ids});
                if (ret === 1000) {
                    this.$message.success('删除成功');
                    this.selUrlID = "";
                    await this.getUrlList();
                }
            },

            handleSelectionChange(val) {
                if (val.length === 0) {
                    return;
                }
                let ids = "";
                for (const item of val) {
                    ids += item.id + ",";
                }
                ids = ids.substr(0, ids.length - 1);
                this.selUrlID = ids;
            },
            handleCurrentPage(val) {
                this.currentPage = val;
                this.getUrlList();
            },
            handleExpCurrentPage(val) {
                this.expCurrentPage = val;
                this.getExportList();
            },
            handleExportData() {
                this.exportDialog = true;
                if (this.isLoad) {
                    this.isLoad = false;
                    this.getExportList();
                }
            },


            showQrCode(txt) {
                if (txt === '') {
                    this.$message.error('出错了！刷新试试看！');
                    return;
                }
                this.qrCodeDialog = true;
                const $this = this;
                setTimeout(function () {
                    $this.$refs.qrCodeDiv.innerHTML = '';
                    new QRCode($this.$refs.qrCodeDiv, {
                        text: txt,
                        width: 200,
                        height: 200,
                        colorDark: "#333333", //二维码颜色
                        colorLight: "#ffffff", //二维码背景色
                        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                    });
                }, 100);
            },
            savePic() {
                let myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
                let a = document.createElement('a');
                a.href = myQrCode[0].toDataURL('image/png');
                a.download = 'linkQrCode';
                a.click();
            },
            saveExcel(url) {
                if (url === '') return;
                let a = document.createElement('a');
                a.href = url;
                a.download = 'linkExcel';
                a.click();
            },
            //上传图片
            async Upload(file) {
                const that = this;
                const id = this.id;
                if(this.img_count > 200){
                    this.$message.error('图片数量已经超过200！');
                    return
                }
                // const api = this.$api;
                async function multipartUpload() {
                    let temporary = file.file.name.lastIndexOf(".");
                    let fileNameLength = file.file.name.length;
                    let fileFormat = file.file.name.substring(
                        temporary + 1,
                        fileNameLength
                    );
                    let fileName = getFileNameUUID() + "." + fileFormat;
                    client(that.dataObj)
                        .multipartUpload(`ai/dwz/${fileName}`, file.file, {
                            progress: function(p) {
                                //p进度条的值
                                console.log(p);
                                that.showProgress = true;
                                that.progress = Math.floor(p * 100);
                            }
                        })
                        .then(async () => {
                            //上传成功返回值，可针对项目需求写其他逻辑
                            // console.log(result);
                            const getData = {
                                use_img: 'ai/dwz/'+fileName,
                                product_id:that.product_id,
                                params:that.beishu,
                                id:id
                            };
                            const {ret} = await  that.$api.imgbig.create(getData);
                            console.log(ret)
                            if (ret === 1000) {
                                that.getLinkInfo();
                                that.$message.success('添加成功');
                            }

                        })
                        .catch(err => {
                            console.log("err:", err);
                        });
                }
                multipartUpload();
            },

            handleSuccess(response, file, fileList) {
                this.fileList = fileList;
            },
            // 上传检查图片
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const ispng = file.type === 'image/png';
                const isgif = file.type === 'image/gif';
                const isbmp = file.type === 'image/bmp';
                const ispdf = file.type === 'image/pdf';
                const isGIF = file.type === 'image/GIF';
                const isLt2M = file.size / 1024 / 1024 < 5;

                console.log(file.type);
                if (!isJPG && !ispng && !isgif && !isbmp && !ispdf && !isGIF) {
                    this.$message.error('上传图片格式不正确!');
                    return false
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 5MB!');
                    return false
                }
                return isLt2M;
            },
            // 删除文件之前的钩子
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            //上传图片后确定按钮
            async imgAccomplish() {
                this.oldDialog = false;
                this.fileList = [];
                this.getList()
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
        }
    }
</script>

<style scoped>
    .su-top {
        width: 100%;
        height: auto;
        padding: 20px;
    }

    .su-top .su-item {
        width: 100%;
        height: 40px;
        color: #666666;
        margin-bottom: 10px;
    }

    .su-top .su-item .lab {
        display: inline-block;
        width: 80px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }

    .su-top .su-item .opt {
        display: inline-block;
        width: 350px;
        height: 40px;
        vertical-align: top;
    }

    .su-top .su-item .inp {
        width: 350px;
    }

    .su-top .btn-features {
        width: 100%;
        height: 40px;
        margin-top: 30px;
    }

    .su-mid {
        width: 100%;
        padding: 0 20px;
    }

    .su-mid .lim {
        width: 100%;
        height: 24px;
    }

    .su-mid .lim .l {
        display: inline-block;
        width: 242px;
        height: 24px;
        overflow: hidden;
        vertical-align: top;
    }

    .su-mid .lim .l .links {
        display: inline-block;
        /*width: 214px;*/
        height: 24px;
        color: #409EFF;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: top;
    }

    .su-mid .lim .l .links:hover {
        color: #66b1ff;
        text-decoration: underline;
    }

    .su-mid .lim .r {
        display: inline-block;
        width: 28px;
        height: 24px;
        cursor: pointer;
        margin-left: 10px;
        vertical-align: top;
    }

    .su-mid .icon {
        cursor: pointer;
        font-size: 28px;
    }

    .su-mid .icon:hover {
        color: #409EFF;
    }

    .su-mid .class {
        color: #409EFF;
        cursor: pointer;
    }

    .pagebar {
        width: 100%;
        height: 52px;
        margin-top: 20px;
    }

    .link-qr-code {
        width: 200px;
        height: 200px;
        margin: 0 auto;
    }

    .opt-link {
        color: #409EFF;
        margin-right: 5px;
        white-space: nowrap;
    }

    .link-mark {
        width: 100px;
        min-height: 23px;
    }

    .exp_box {
        width: 100%;
    }

    .exp_box .exp_title {
        width: 100%;
        height: auto;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .exp_box .exp_head {
        width: 100%;
        height: 40px;
        margin-bottom: 20px;
    }

    .exp_box .exp_head .lab {
        display: inline-block;
        width: auto;
        height: 40px;
        line-height: 40px;
        margin: 0 5px;
        vertical-align: top;
    }

    .exp_box .exp_head .sel {
        width: 160px;
    }

    .exp_box .exp_head .inp {
        margin-left: 10px;
    }

    .replace {
        width: 100%;
        height: auto;
    }

    .replace .item {
        width: 100%;
        height: 40px;
        line-height: 40px;
    }

    .replace .item .l {
        display: inline-block;
        width: 60px;
        height: 40px;
        vertical-align: top;
    }

    .replace .item .r {
        display: inline-block;
        width: 290px;
        height: 40px;
        vertical-align: top;
    }

    .exc_color {
        color: #f6ab16 !important;
    }
</style>
